import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("App error boundary:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-6 text-center">
          <h1 className="text-2xl font-bold text-foreground">Er ging iets mis</h1>
          <p className="text-muted-foreground max-w-md">
            De pagina kon niet geladen worden. Probeer het opnieuw.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="inline-flex h-11 items-center justify-center rounded-lg bg-primary px-6 text-sm font-semibold text-primary-foreground"
          >
            Pagina herladen
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
